<template>
    <div class="index-page">
        <div class="index-top-box">
            <img src="@/assets/Image/index-img-01.png" class="index-img" />                    
        </div>
        <div class="index-img-box">
            <div class="index-img-top">
                <img src="@/assets/Image/index-img-02.png" class="index-img" /> 
                <div class="top-title-desc-box">
                    <div class="top-title">{{ componeyInfo.name }}</div>
                    <div class="top-desc">{{ componeyInfo.desc }}</div>
                </div> 
                <div class="top-paibian-name">
                    <div :class="['comp-name',planCompantNameLen(componeyInfo.name)]">{{ componeyInfo.name }}</div>
                    <img src="@/assets/Image/paibian-mu.png" class="top-img-paibian" />  
                </div>
                <div :class="['top-img-select-box',fixedBottomReceiveBtn?'bottom-btn-promiseBook-box':'']">                   
                    <img src="@/assets/Image/index-img-02-btn.png"  @click="receiveFun()" class="top-img-btn" />  
                    <div class="promiseBook-box">
                        <img class="promiseBook-img"
                            @click="commitment = true"
                            v-show="!commitment"
                            src="@/assets/icon/index-noSelected-icon.png"
                        />
                        <img class="promiseBook-img"
                            @click="commitment = false"
                            v-show="commitment"
                            src="@/assets/icon/index-selected-icon.png"
                        />
                        <div class="promiseBook"> 
                            <span class="promiseBook-p" @click="commitment = !commitment">同意签署</span>
                            <span class="promiseBook-span" @click="lookFun()">《守信承诺书》</span>
                        </div>
                    </div>
                </div>                  
            </div>
            <div class="index-img-centent">
                <img src="@/assets/Image/index-img-03.png" @click="receiveFun()" class="index-img" />                    
                <img src="@/assets/Image/index-img-04.png" @click="receiveFun()" class="index-img" />                    
            </div>
            <aboutUsC />
        </div>  
         <!-- 收货弹窗 -->
        <shippingC @submit="submitFun" @addressPopupClose="addressPopupStatus=false" v-if="addressPopupStatus" />
        <!-- 守信承诺书 -->
        <commitmentC :book="book" ref="commitmentRef" />     
    </div>
</template>

<script>
import commitmentC from "@/components/commitment";
import shippingC from "@/components/shipping";
import aboutUsC from "@/components/aboutUs";
import {
    orderInfoApi,
    indexApi,
    saveAddressApi,
    openidApi,
} from "@/api/index.js";
export default {
    name: "index",
    components: {
        aboutUsC,
        shippingC,
        commitmentC,
    },
    data() {
        return {
            addressPopupStatus:false,    //地址弹窗状态
            fixedBottomReceiveBtn: false, //是否置底领取按钮            
            scrollHeight: 0,    //判断是否显示置底领取按钮的滚动高度
            checkList: [
                {
                    val: true,
                    text: "无失信被执行",
                },
                {
                    val: true,
                    text: "无经营异常",
                },
                {
                    val: true,
                    text: "无负面舆情",
                },
            ],
            commitment: true,
            cid: "52",
            componeyInfo: {
                desc: "自 XX 年成立，经营期间",
                name: "公司 / 个体户名称 XXXXXX",
                img: "",
            },
            book: {
                title: "",
                content: "",
                name: "",
            },
            code: null,
        };
    },
    created() {
        let self = this;
        if(self.$route.params.cid)self.cid = self.$route.params.cid;
        // console.log('****************',self.cid,self.util)
        // console.log(self.$store.state.is_weixin_app,self.$route.query.code)
        if (self.$store.state.is_weixin_app) {
            // self.code = self.$route.query.code;
            // if (!self.code) {
            //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe225cccbbb5eaac6&redirect_uri=${encodeURIComponent('https://youxin-gov.cn/'+self.cid)}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
            // } else {
                if (self.cid) {
                    self.openIdFun();
                    self.orderInfoApiFun();
                } else {
                    self.$toast("企业ID为空");
                }
            // }
        } else {
            if (self.cid) {
                self.orderInfoApiFun();
            } else {
                self.$toast("企业ID为空");
            }
        }
    },
    mounted() {
        let self = this;  
        //监听滚动事件
        window.addEventListener("scroll", function () {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // console.log(scrollTop);
            if(self.scrollHeight && scrollTop > self.scrollHeight){
                self.fixedBottomReceiveBtn = true;
            } else {
                self.fixedBottomReceiveBtn = false;
            }
        });
    },
    methods: {
        openIdFun() {
            openidApi({
                cid: this.cid,
                wxcode: this.code,
            }).then((res) => {
                console.log(res);
            });
        },
        orderInfoApiFun() {
            let self = this;
            // console.log("323");
            orderInfoApi(self.cid).then((res) => {
                if(res.code == 200){
                    if(res.data.ispay) {
                        self.util.skipUrl('/succeed/'+self.cid,{},'replace');
                    } else {
                        self.indexApiFun();                        
                    }
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }               
            });
        },
        indexApiFun() {
            let self = this;            
            indexApi(self.cid).then((res) => {
                if(res.code == 200){
                    self.componeyInfo.desc = res.data.comp_desc;
                    self.componeyInfo.name = res.data.comp_name;
                    self.$store.commit("CHANGE_COMPANY_NAME", {
                        name: res.data.comp_name,
                    });
                    self.book.name = res.data.comp_name;
                    self.book.title = res.data.shouxin_agreement.title;
                    self.book.content = res.data.shouxin_agreement.info;
                    let info = res.data.shipping_address;
                    if (info) {
                        let option = {
                            name: info.name,
                            phone: info.mobile,
                            provinces:
                                info.pro_code_format +
                                info.city_code_format +
                                info.gov_code_format,
                            site: info.address,
                            provincesCode: [
                                info.pro_code,
                                info.city_code,
                                info.gov_code,
                            ],
                            provincesName: [
                                info.pro_code_format,
                                info.city_code_format,
                                info.gov_code_format,
                            ],
                        };
                        self.setlocalStorageFun(option);
                    } else {
                        window.localStorage.removeItem("address_yuixin");
                    }
                    let option = self.util.shareData();
                    option.link = `${location.origin}/${self.cid}`;
                    option.title = res.data.comp_name;
                    // console.log(option)
                    //微信分享触发事件
                    self.util.weixinShareFun(option);

                    //取浏览器窗口的内部高度
                    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    //获取当前元素的高度
                    let topImgSelectBoxClient = {};
                    //滚动到页面顶部
                    window.scrollTo(0, 0);
                    self.$nextTick(() => {
                        // console.log('mounted-----',document.querySelector('.top-img-select-box').getBoundingClientRect());
                        //获取当前元素的高度
                        topImgSelectBoxClient = document.querySelector('.top-img-select-box').getBoundingClientRect();
                        //判断是否显示置底领取按钮的滚动高度
                        self.scrollHeight = topImgSelectBoxClient.top - clientHeight + topImgSelectBoxClient.height;
                        // console.log(clientHeight , topImgSelectBoxClient.height,self.scrollHeight);
                    });  
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }                
            });
        },
        //查看守信承诺书
        lookFun() {
            this.$refs.commitmentRef.showFun();
        },
        //点击同意签署才显示选择地址
        receiveFun() {
            if (!this.commitment) return this.$toast("请勾选同意签署,再领取");
            this.addressPopupStatus = true;
        },
        setlocalStorageFun(option) {
            window.localStorage.setItem(
                "address_yuixin",
                JSON.stringify(option)
            );
        },
        //选择完地址后跳转
        submitFun(option) {
            let self = this;
            self.addressPopupStatus = false;    //地址弹窗状态
            let data = {
                cid: this.cid,
                name: option.name,
                mobile: option.phone,
                pro_code: option.provincesCode[0],
                city_code: option.provincesCode[1],
                gov_code: option.provincesCode[2],
                address: option.site,
            };
            // console.log(data);
            saveAddressApi(data).then((res) => {
                if(res.code == 200){
                    self.setlocalStorageFun(option);
                    self.$router.push({
                        path: "/payment/"+self.cid,
                        query: {
                            cid: self.cid,
                        },
                    });
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }
            });
        },
        //企业名称长度选择字体大小
        planCompantNameLen(str){
            // console.log(str.length)
            let className = "";
            if(str.length>14 && str.length<17){
                className = "comp-name-12";
            }else if(str.length>16 && str.length<20){
                className = "comp-name-11";
            }else if(str.length>19){
                className = "comp-name-10";
            }
            return className;
        }
    },
};
</script>

<style lang="less" scoped>
.index-page{
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('../../assets/Image/bg.png') no-repeat;
    background-position: top center;  
    background-size: 100% 100%;  
    .index-img{
        width: 100%;
        display: block;
    }
    .index-top-box{
        width: 375px;                
    }
    .index-img-box{
        margin-top: -99px;
        width: 340px;   
        padding-bottom: 130px;  
        .index-img-top{
            margin-bottom: 20px;  
            width: 100%;       
            position: relative;
            .top-title-desc-box{
                width: 100%;
                position: absolute;
                top: 25px;
                left: 0;z-index: 3; 
                display: flex;
                flex-direction: column;
                align-items: center;
                .top-title{
                    width: 94%;
                    padding: 0 15px;
                    font-size: 26px;
                    color: #885834;
                    font-weight: bold;
                    line-height: 30px;
                    margin-bottom: 8px;
                    white-space: nowrap;     //规定段落中的文本不进行换行
                    text-overflow: ellipsis;   //属性规定当文本溢出包含元素时发生的事情。
                    overflow: hidden;
                }
                .top-desc{
                    font-size: 14px;
                    font-weight: 500;
                    color: rgba(133, 79, 45, 0.8);
                    line-height: 20px;
                }
            }
            .top-paibian-name{
                width: 100%;
                position: absolute;
                bottom: 134px;
                left: 0;
                z-index: 3;                 
                display: flex;
                flex-direction: column;
                align-items: center; 
                .comp-name {
                    width: 200px;
                    position: absolute;
                    top: 50px;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 13px;
                    text-align: center;
                }
                .comp-name-12{
                    top: 50px;
                    font-size: 12px;
                }
                .comp-name-11{
                    top: 46px;
                    font-size: 11px;
                }
                .comp-name-10{
                    top: 46px;
                    font-size: 10px;
                }
                .top-img-paibian{
                    width: 290px;
                    display: block;
                }   
            }
            .top-img-select-box{
                width: 100%;
                position: absolute;
                bottom: 15px;
                left: 0;
                z-index: 3; 
                padding-bottom: 15px;
                display: flex;
                flex-direction: column;
                align-items: center; 
                .top-img-btn{
                    margin-top: 10px;   
                    width: 100%;
                    display: block;
                }   
                .promiseBook-box{
                    width: 100%;
                    position: absolute;
                    left: 0;bottom: 15px;z-index: 3;   
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .promiseBook-img{
                        width: 14px;
                        height: 14px;
                        display: block;
                    }   
                    .promiseBook{
                        margin-left: 8px;  
                        .promiseBook-p{
                            font-size: 14px;
                            color: #854F2D;
                            line-height: 16px;
                        }
                        .promiseBook-span{ 
                            font-size: 14px;
                            color: #CC8C4E;
                            line-height: 16px;
                        }
                    } 
                }  
            }
            // .置底的按钮
            .bottom-btn-promiseBook-box{
                width: 100%;
                padding: 0 17.5px 15px 17.5px;
                position: fixed;
                bottom: 0;
                left: 0;
                z-index: 99; 
                display: flex;
                flex-direction: column;
                align-items: center; 
                background-color: #FFFFFF;
                box-sizing: border-box;                
            }
        }          
        .index-img-centent{
            margin-bottom: 20px;   
            width: 100%;             
        }       
    }
}
</style>